"use strict";

exports.__esModule = true;
exports.menuItemTheme = exports.menuGroupTheme = exports.menuDividerTheme = void 0;

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var menuDividerTheme = function menuDividerTheme(baseTheme) {
  return _objectSpread({
    MenuDivider_borderColor: baseTheme.borderColor,
    MenuDivider_borderWidth: '1px',
    MenuDivider_margin: baseTheme.space_stack_sm
  }, baseTheme);
}; // [1] Deviation from h5 for optics relative to a MenuItem


exports.menuDividerTheme = menuDividerTheme;

var menuGroupTheme = function menuGroupTheme(baseTheme) {
  return _objectSpread({
    MenuGroupTitle_fontSize: baseTheme.fontSize_mouse,
    // [1]
    MenuGroupTitle_fontWeight: baseTheme.h5_fontWeight,
    MenuGroupTitle_marginTop: baseTheme.space_stack_sm,
    MenuGroupTitle_paddingTop: baseTheme.space_stack_md,
    MenuGroupTitle_paddingBottom: baseTheme.space_stack_sm
  }, baseTheme);
}; // Some of these values (all of the margins & paddings and the content fontSize)
// come from Button (large)
// prettier-ignore


exports.menuGroupTheme = menuGroupTheme;

var menuItemTheme = function menuItemTheme(baseTheme) {
  return _objectSpread({
    MenuItem_backgroundColor_selected: baseTheme.backgroundColor_theme_selected,
    MenuItem_backgroundColor_active: baseTheme.color_gray_20,
    MenuItem_backgroundColor_focus: baseTheme.color_gray_10,
    MenuItem_backgroundColor_hover: baseTheme.color_gray_10,
    MenuItem_backgroundColor_selectedActive: baseTheme.backgroundColor_theme_selectedActive,
    MenuItem_backgroundColor_selectedHover: baseTheme.backgroundColor_theme_selectedHover,
    MenuItem_color: baseTheme.color,
    MenuItem_fontWeight: baseTheme.fontWeight_regular,
    MenuItem_fontWeight_selected: baseTheme.fontWeight_bold,
    MenuItem_paddingHorizontal: baseTheme.space_inset_md,
    MenuItem_paddingVertical: baseTheme.space_inset_sm,
    MenuItemContent_fontSize: baseTheme.fontSize_ui,
    MenuItemIcon_color: baseTheme.icon_color_theme,
    MenuItemIcon_margin: baseTheme.space_inset_sm,
    MenuItemSecondaryText_color: baseTheme.color_mouse,
    MenuItemSecondaryText_fontSize: baseTheme.fontSize_mouse
  }, baseTheme);
};

exports.menuItemTheme = menuItemTheme;